import { createApp } from 'vue'
import App from './App.vue'
import Vant from 'vant';
import router from './router';
import 'vant/lib/index.css';



import { ConfigProvider } from 'vant';

const app = createApp(App);


app.use(Vant);
app.use(router);
app.use(ConfigProvider);



app.mount('#app');
